"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentExample = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const component_styles_1 = require("@/components/domains/component/component.styles");
let ComponentExample = class ComponentExample extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.width = '';
        this.fullWidth = false;
    }
    render() {
        return (0, lit_1.html) `
      <section class="component-example component-content-frame">
        <slot></slot>
      </section>
    `;
    }
};
ComponentExample.styles = component_styles_1.componentExampleStyles;
__decorate([
    (0, decorators_js_1.property)({ type: String, reflect: true })
], ComponentExample.prototype, "width", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean, attribute: 'full-width', reflect: true })
], ComponentExample.prototype, "fullWidth", void 0);
ComponentExample = __decorate([
    (0, decorators_js_1.customElement)('mm-component-example')
], ComponentExample);
exports.ComponentExample = ComponentExample;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29tcG9uZW50LWV4YW1wbGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJjb21wb25lbnQtZXhhbXBsZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSw2QkFBc0M7QUFDdEMscURBQTJEO0FBRTNELHNGQUF3RjtBQUdqRixJQUFNLGdCQUFnQixHQUF0QixNQUFNLGdCQUFpQixTQUFRLGdCQUFVO0lBQXpDOztRQUVzQyxVQUFLLEdBQWtCLEVBQUUsQ0FBQTtRQUNDLGNBQVMsR0FBRyxLQUFLLENBQUE7SUFTeEYsQ0FBQztJQVBDLE1BQU07UUFDSixPQUFPLElBQUEsVUFBSSxFQUFBOzs7O0tBSVYsQ0FBQTtJQUNILENBQUM7O0FBVk0sdUJBQU0sR0FBRyx5Q0FBc0IsQ0FBQTtBQUNLO0lBQTFDLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsT0FBTyxFQUFFLElBQUksRUFBRSxDQUFDOytDQUEwQjtBQUNDO0lBQXBFLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxPQUFPLEVBQUUsU0FBUyxFQUFFLFlBQVksRUFBRSxPQUFPLEVBQUUsSUFBSSxFQUFFLENBQUM7bURBQWtCO0FBSDNFLGdCQUFnQjtJQUQ1QixJQUFBLDZCQUFhLEVBQUMsc0JBQXNCLENBQUM7R0FDekIsZ0JBQWdCLENBWTVCO0FBWlksNENBQWdCIn0=